"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var propTypes = {
  children: _stencilReactDesc.PropTypes.node.description('Text to display in the tag.'),
  onDismiss: _stencilReactDesc.PropTypes.func.description('Function called when the user clicks the X button in the tag. The argument allows to distinguish whether the action was triggered by mouse or keyboard.').format("(triggeredBy: 'keyboard' | 'mouse' ) => void"),
  dismissButtonAltText: _stencilReactDesc.PropTypes.string.description('Alt text used for the X button in the tag.'),
  avatarUsername: _stencilReactDesc.PropTypes.string.description('Username of an employee to display as an avatar in the tag.'),
  avatarEmployeeId: _stencilReactDesc.PropTypes.string.description('Unique employee ID of an employee to display as an avatar in the tag.'),
  backgroundColor: _stencilReactDesc.PropTypes.string.description('Sets the background color for the tag. Does not affect the text color, so only colors with enough contrast should be used.'),
  tagDeleteButtonRef: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.func, _stencilReactDesc.PropTypes.shape({
    current: _stencilReactDesc.PropTypes.any
  })]).description('Reference to attach to delete button.')
};
var _default = propTypes;
exports.default = _default;